<!--
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2020-12-23 14:56:54
 * @LastEditTime: 2020-12-25 16:46:42
-->
<template>
  <button
    type="primary"
    :style="btnStyle"
    :class="{active:isLoading}"
    :loading="isLoading"
    @click="_confirmEvent"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    btnStyle: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    _confirmEvent() {
      if (this.loading) {
        if (this.isLoading) {
          return null;
        }
        this.isLoading = true;
      }
      //触发回调
      this.$emit("confirmEvent", () => {
        this.done();
      });
    },
    done() {
      this.isLoading = false;
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.icon-loading {
  width: 40rpx;
  height: 40rpx;
  margin-right: 20rpx;
}
button{
  border: 0;
}
.active{
  opacity: 0.6;
}
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: rgba(222, 71, 67, 1);
  height: 84rpx;
  font-size: 32rpx;
  font-weight: 400;
  letter-spacing: 3rpx;
}

.button-loading {
  background: rgba(222, 71, 67, 0.7);
}
</style>
